import { render, staticRenderFns } from "./SupportedProducts.vue?vue&type=template&id=148722dc&"
import script from "./SupportedProducts.vue?vue&type=script&lang=js&"
export * from "./SupportedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports